import NewPass from './NewPass';

export default NewPass;
